import styled from '@emotion/styled';
import { TypographyComponent } from 'components/Typography';
import { palette, pxToEm, theme } from 'theme';

export const Container = styled.div<{ show: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 0 ${pxToEm(32)} 0 ${pxToEm(8)};
  width: ${pxToEm(400)};
  flex: none;
  margin-right: ${pxToEm(150)};
  opacity: ${({ show }) => (show ? 1 : 0)};
  transition: opacity 0.3s ease;

  ${theme.breakpoints.down('md')} {
    padding: 0 ${pxToEm(6)};
    width: auto;
    margin-right: 0;
    opacity: 1;
  }
`;

export const Subheader = styled(TypographyComponent)`
  margin-bottom: ${pxToEm(8)};
  color: ${({ color }) => (color ? color : palette.primary.main)};
  ${theme.breakpoints.down('md')} {
    margin-bottom: ${pxToEm(4)};
  }
`;

export const Title = styled(TypographyComponent)`
  font-size: ${pxToEm(32)};
  line-height: 1.25;
  font-weight: 600;
  color: ${({ color }) => (color ? color : palette.primary.main)};

  ${theme.breakpoints.down('md')} {
    font-size: ${pxToEm(24)};
    margin-bottom: ${pxToEm(16)};
  }
`;

export const Description = styled(TypographyComponent)`
  margin-top: ${pxToEm(16)};
  margin-bottom: ${pxToEm(8)};
  color: ${({ color }) => (color ? color : palette.primary.main)};

  ${theme.breakpoints.down('md')} {
    display: none;
  }
`;
